import { useEffect, useState } from 'react'

const useIsOlderThan = (
  date: Date | null | undefined,
  seconds: number
): boolean => {
  const [isOlder, setIsOlder] = useState(false)

  useEffect(() => {
    const checkIfOlderThan = () => {
      if (date instanceof Date) {
        const now = new Date()
        const difference = Math.floor((now.getTime() - date.getTime()) / 1000)
        setIsOlder(difference >= seconds)
      } else {
        setIsOlder(false)
      }
    }

    checkIfOlderThan()
    const interval = setInterval(checkIfOlderThan, 1000)

    return () => clearInterval(interval)
  }, [date, seconds])

  return isOlder
}

export default useIsOlderThan
